import { render, staticRenderFns } from "./InfoPopupBlock.vue?vue&type=template&id=617e3902&scoped=true&"
import script from "./InfoPopupBlock.vue?vue&type=script&lang=js&"
export * from "./InfoPopupBlock.vue?vue&type=script&lang=js&"
import style0 from "./InfoPopupBlock.vue?vue&type=style&index=0&id=617e3902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e3902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
